<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g>
    <path fill="none" d="M134,84H66c-4.411,0-8,3.589-8,8v49c0,4.411,3.589,8,8,8h68c4.411,0,8-3.589,8-8V92
      C142,87.589,138.411,84,134,84z M106.852,122.398c0.358,0.916,0.562,1.91,0.562,2.951c0,4.489-3.652,8.142-8.141,8.142
      c-4.49,0-8.143-3.652-8.143-8.142c0-1.042,0.204-2.035,0.562-2.952c-2.584-2.169-4.232-5.418-4.232-9.048
      c0-6.514,5.299-11.812,11.812-11.812s11.812,5.299,11.812,11.812C111.086,116.98,109.438,120.23,106.852,122.398z"/>
    <path fill="none" d="M128,76V59c0-4.411-3.589-8-8-8H77c-4.411,0-8,3.589-8,8v17H128z"/>
    <path class="color" fill="#F45B5B" d="M136,76.139V59c0-8.822-7.178-16-16-16H77c-8.822,0-16,7.178-16,16v17.812C54.621,78.917,50,84.925,50,92
      v49c0,8.822,7.178,16,16,16h68c8.822,0,16-7.178,16-16V92C150,83.856,143.88,77.128,136,76.139z M77,51h43c4.411,0,8,3.589,8,8v17
      H69V59C69,54.589,72.589,51,77,51z M142,141c0,4.411-3.589,8-8,8H66c-4.411,0-8-3.589-8-8V92c0-4.411,3.589-8,8-8h68
      c4.411,0,8,3.589,8,8V141z"/>
    <path class="color" fill="#F45B5B" d="M99.273,101.537c-6.514,0-11.812,5.299-11.812,11.812c0,3.63,1.648,6.879,4.232,9.048
      c-0.358,0.917-0.562,1.91-0.562,2.952c0,4.489,3.653,8.142,8.143,8.142c4.488,0,8.141-3.652,8.141-8.142
      c0-1.041-0.204-2.035-0.562-2.951c2.586-2.168,4.234-5.418,4.234-9.049C111.086,106.836,105.787,101.537,99.273,101.537z"/>
  </g>
  </svg>

</template>

<script>
export default {
  name: 'LockIcon'
}
</script>
